import { gql } from "@apollo/client";

export const QUERY_NOTIFICATION_SETTINGS = gql`
  query notificationSettings {
    notificationSettings {
      id
      category
      userRole
      isEnable
      deliveryModes
    }
  }
`;

export const UPDATE_NOTIFICATION_SETTINGS = gql`
  mutation updateNotificationSetting(
    $id: ID!
    $input: NotificationSettingInput!
  ) {
    updateNotificationSetting(id: $id, input: $input) {
      id
      category
      userRole
      isEnable
      deliveryModes
    }
  }
`;
